export function getAllPeruAddress() {
  return {
    province_list: {
      110000: 'Lima',
      120000: 'Amazonas',
      130000: 'Ancash',
      140000: 'Apurímac',
      150000: 'Arequipa',
      160000: 'Ayacucho',
      170000: 'Cajamarca',
      180000: 'Callao',
      190000: 'Cusco',
      200000: 'Huancavelica',
      210000: 'Huánuco',
      220000: 'Ica',
      230000: 'Junín',
      240000: 'La Libertad',
      250000: 'Lambayeque',
      260000: 'Departamento de Lima',
      270000: 'Loreto',
      280000: 'Madre de Dios',
      290000: 'Moquegua',
      300000: 'Pasco',
      310000: 'Piura',
      320000: 'Puno',
      330000: 'San Martín',
      340000: 'Tacna',
      350000: 'Tumbes',
      360000: 'Ucayali',
    },
    city_list: {
      110100: 'Ate',
      110200: 'Barranco',
      110300: 'Breí±a',
      110400: 'Chorrillos',
      110500: 'Comas',
      110600: 'Independencia',
      110700: 'Jesus Maria',
      110800: 'Lima',
      110900: 'La Molina',
      111000: 'Lince',
      111100: 'La Victoria',
      111200: 'La Perla',
      111300: 'Lurin',
      111400: 'Lurigancho',
      111500: 'Miraflores',
      111600: 'Magdalena',
      111700: 'Pueblo Libre',
      111800: 'Pachacamac',
      111900: 'Rimac',
      112000: 'San Isidro',
      112100: 'San Borja',
      112200: 'Santiago de surco',
      112300: 'Santa anita',
      112400: 'Surquillo',
      112500: 'San Miguel',
      112600: 'San Luis',
      112700: 'San Martin de Porres',
      112800: 'San Juan de Miraflores',
      112900: 'San Juan de Lurigancho',
      113000: 'Villa el Salvador',
      120100: 'Chachapoyas',
      120200: 'Bagua',
      120300: 'Jumbilla',
      120400: 'Santa María de Nieva',
      120500: 'Lámud',
      120600: 'Mendoza',
      120700: 'Bagua Grande',
      130100: 'Huaraz',
      130200: 'Aija',
      130300: 'Llamellín',
      130400: 'Chacas',
      130500: 'Chiquián',
      130600: 'Carhuaz',
      130700: 'San Luis',
      130800: 'Casma',
      130900: 'Corongo',
      131000: 'Huari',
      131100: 'Huarmey',
      131200: 'Caraz',
      131300: 'Piscobamba',
      131400: 'Ocros',
      131500: 'Cabana',
      131600: 'Pomabamba',
      131700: 'Recuay',
      131800: 'Chimbote',
      131900: 'Sihuas',
      132000: 'Yungay',
      140100: 'Abancay',
      140200: 'Andahuaylas',
      140300: 'Antabamba',
      140400: 'Chalhuanca',
      140500: 'Tambobamba',
      140600: 'Chincheros',
      140700: 'Chuquibambilla',
      150100: 'Arequipa',
      150200: 'Camaná',
      150300: 'Caravelí',
      150400: 'Aplao',
      150500: 'Chivay',
      150600: 'Chuquibamba',
      150700: 'Mollendo',
      150800: 'Cotahuasi',
      160100: 'Ayacucho',
      160200: 'Cangallo',
      160300: 'Huanca Sancos',
      160400: 'Huanta',
      160500: 'San Miguel',
      160600: 'Puquio',
      160700: 'Coracora',
      160800: 'Pausa',
      160900: 'Querobamba',
      161000: 'Huancapi',
      161100: 'Vilcashuamán',
      170100: 'Cajamarca',
      170200: 'Cajabamba',
      170300: 'Celendín',
      170400: 'Chota',
      170500: 'Contumazá',
      170600: 'Cutervo',
      170700: 'Bambamarca',
      170800: 'Jaén',
      170900: 'San Ignacio',
      171000: 'San Marcos',
      171100: 'San Miguel de Pallaques',
      171200: 'San Pablo',
      171300: 'Santa Cruz de Succhubamba',
      180100: 'Callao',
      190100: 'Cusco',
      190200: 'Acomayo',
      190300: 'Anta',
      190400: 'Calca',
      190500: 'Yanaoca',
      190600: 'Sicuani',
      190700: 'Santo Tomás',
      190800: 'Yauri',
      190900: 'Quillabamba',
      191000: 'Paruro',
      191100: 'Paucartambo',
      191200: 'Urcos',
      191300: 'Urubamba',
      200100: 'Huancavelica',
      200200: 'Acobamba',
      200300: 'Lircay',
      200400: 'Castrovirreyna',
      200500: 'Churcampa',
      200600: 'Huaytará',
      200700: 'Pampas',
      210100: 'Huánuco',
      210200: 'Ambo',
      210300: 'La Unión',
      210400: 'Huacaybamba',
      210500: 'Llata',
      210600: 'Tingo María',
      210700: 'Huacrachuco',
      210800: 'Panao',
      210900: 'Puerto Inca',
      211000: 'Jesús',
      211100: 'Chavinillo',
      220100: 'Ica',
      220200: 'Chincha Alta',
      220300: 'Nazca',
      220400: 'Palpa',
      220500: 'Pisco',
      230100: 'Huancayo',
      230200: 'Concepción',
      230300: 'La Merced',
      230400: 'Jauja',
      230500: 'Junín',
      230600: 'Satipo',
      230700: 'Tarma',
      230800: 'La Oroya',
      230900: 'Chupaca',
      240100: 'Trujillo',
      240200: 'Ascope',
      240300: 'Bolívar',
      240400: 'Chepén',
      240500: 'Julcán',
      240600: 'Otuzco',
      240700: 'San Pedro de Lloc',
      240800: 'Tayabamba',
      240900: 'Huamachuco',
      241000: 'Santiago de Chuco',
      241100: 'Cascas',
      241200: 'Virú',
      250100: 'Chiclayo',
      250200: 'Ferreí±afe',
      250300: 'Lambayeque',
      260100: 'Huacho',
      260200: 'Barranca',
      260300: 'Cajatambo',
      260400: 'Canta',
      260500: 'San Vicente de Caí±ete',
      260600: 'Huaral',
      260700: 'Matucana',
      260800: 'Oyón',
      260900: 'Yauyos',
      270100: 'Iquitos',
      270200: 'Yurimaguas',
      270300: 'Nauta',
      270400: 'Caballococha',
      270500: 'San Antonio del Estrecho',
      270600: 'Requena',
      270700: 'Contamana',
      270800: 'San Lorenzo',
      280100: 'Puerto Maldonado',
      280200: 'Salvación',
      280300: 'Ií±apari',
      290100: 'Moquegua',
      290200: 'Omate',
      290300: 'Ilo',
      300100: 'Cerro de Pasco',
      300200: 'Yanahuanca',
      300300: 'Oxapampa',
      310100: 'Piura',
      310200: 'Ayabaca',
      310300: 'Huancabamba',
      310400: 'Chulucanas',
      310500: 'Paita',
      310600: 'Sullana',
      310700: 'Talara',
      310800: 'Sechura',
      320100: 'Puno',
      320200: 'Azángaro',
      320300: 'Macusani',
      320400: 'Juli',
      320500: 'Ilave',
      320600: 'Huancané',
      320700: 'Lampa',
      320800: 'Ayaviri',
      320900: 'Moho',
      321000: 'Putina',
      321100: 'Juliaca',
      321200: 'Sandia',
      321300: 'Yunguyo',
      330100: 'Moyobamba',
      330200: 'Bellavista',
      330300: 'San José de Sisa',
      330400: 'Saposoa',
      330500: 'Lamas',
      330600: 'Juanjuí',
      330700: 'Picota',
      330800: 'Rioja',
      330900: 'Tarapoto',
      331000: 'Tocache',
      340100: 'Tacna',
      340200: 'Candarave',
      340300: 'Locumba',
      340400: 'Tarata',
      350100: 'Tumbes',
      350200: 'Zorritos',
      350300: 'Zarumilla',
      360100: 'Pucallpa',
      360200: 'Atalaya',
      360300: 'Aguaytía',
      360400: 'Esperanza',
    },
  }
}
